import {
    TiersAppDispatch,
    SOUS_CLIENT_SLICE_NAME,
    PrescripteurApi,
} from '@europrocurement/l2d-domain';

import { CenterCircularProgress } from '@europrocurement/flexy-components';

import { useDispatch } from 'react-redux';
import React, { useEffect } from 'react';

import { useCurrentPrescriber } from '@europrocurement/l2d-modules/hooks/useCurrentPrescriber';
import ListeSousClient, { ComponentListeSousClientProps } from './ListeSousClient';

const ListeSousClientPrescripteurWrapper: React.FunctionComponent<ComponentListeSousClientProps> =
    function ({ showPrescripteur = false }) {
        const dispatch = useDispatch<TiersAppDispatch>();

        let prescripteur: PrescripteurApi | undefined;
        useEffect(
            () => () => {
                dispatch({
                    type: `${SOUS_CLIENT_SLICE_NAME}/resetmainFilter`,
                });
            },
            // eslint-disable-next-line react-hooks/exhaustive-deps
            [],
        );
        try {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            prescripteur = useCurrentPrescriber();
        } catch (error) {
            console.log(error);
            return <CenterCircularProgress />;
        }

        if (prescripteur) {
            dispatch({
                type: `${SOUS_CLIENT_SLICE_NAME}/setmainFilter`,
                payload: {
                    key: 'prescripteurId',
                    value: prescripteur.id,
                },
            });
        }

        return <ListeSousClient showPrescripteur={showPrescripteur} />;
    };

export default ListeSousClientPrescripteurWrapper;
